import { render, staticRenderFns } from "./PriceCalculatorView.vue?vue&type=template&id=96fbed90&scoped=true"
import script from "./PriceCalculatorView.vue?vue&type=script&lang=js"
export * from "./PriceCalculatorView.vue?vue&type=script&lang=js"
import style0 from "./PriceCalculatorView.vue?vue&type=style&index=0&id=96fbed90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fbed90",
  null
  
)

export default component.exports